<template>
    <vue-autocomplete
    class="w-100"
    :data="items"
    placeholder="Digite Para Pesquisar Municípios..."
    v-model="query"
    :serializer="item => item.nome"
    @hit="selecionarCidade($event)"
    @input="buscarCidadesPorEstado"
    showOnFocus
    :disabled="disabled"
    :maxMatches=parseInt(5)>
  <template slot="suggestion" slot-scope="{ htmlText }">
    <div class="d-flex">
        <b-spinner v-show="carregando" variant="primary" class="mx-auto"></b-spinner>
        <span class="ml-4" v-html="htmlText" v-show="!carregando"></span>
    </div>
  </template>
</vue-autocomplete>
</template>
<script>
import LocalidadesService from "../../service/LocalidadesService.js";

export default {
	props: [ "disabled", "value" ],
	data() {
		return {
			query: this.value,
			items: [],
			carregando: false,
		};
	},
	watch: {
		query(newValue, oldValue) {
			this.$emit("cidadeSelecionada", newValue);
		},
		value(newValue, oldValue) {
			if (newValue == "") {
				this.query = newValue;
			}
		},
	},
	methods: {
		buscarCidadesPorEstado() {
			this.carregando = true;
			LocalidadesService.listarMunicipios()
				.then((res) => {
					this.items = res.data;
				}).finally(() => {
					this.carregando = false;
				});
		},
		selecionarCidade(item) {
			this.$emit("cidadeSelecionada", item.nome);
		},
		limpar() {
			this.query = "";
			this.items = [];
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/shared/AutoCompleteCidade.vue